module.exports = __webpack_public_path__ + "static/img/8.c170e8ca.png";